module.exports = function(
  $rootScope,
  $scope,
  $state,
  gettextCatalog,
  Notification,
  OfficeModel,
  officeResolve,
  ServiceGroupModal,
  ModalService,
  ServiceModal,
) {
  $scope.groupfilter = '';
  $scope.office = officeResolve;
  $scope.showPremiumNotification = false;

  function checkPremium(serviceGroups) {
    $scope.serviceLen = 0;

    _.forEach(serviceGroups, function(serviceGroup) {
      $scope.serviceLen += serviceGroup.services.length;
    });

    $scope.showPremiumNotification =
      $scope.subscription.onlyBasicFunctions && $scope.serviceLen >= 3;
  }

  $scope.$watch('office.serviceGroups', function(newValue) {
    checkPremium(newValue);
  });

  $scope.getServiceCount = function() {
    var count = 0;

    _.forEach($scope.office.serviceGroups, function(group) {
      count += group.services.length;
    });

    return count;
  };

  /**
   * set active class for group pill navigation (not shown at the moment)
   * @param group
   * @returns {string}
   */
  $scope.getActiveState = function(group) {
    return group === $scope.groupfilter ? 'active' : '';
  };

  /**
   * filter the services by clicking on the groups and set the filter for the ng-repeat (not shown at the moment)
   * @param filter
   */
  $scope.setFilter = function(filter) {
    $scope.groupfilter = filter;
  };

  /**
   *@param service
   */
  $scope.openServiceModal = function(service) {
    ModalService.openServiceModal(service);
    // ServiceModal.open(service);
  };

  /**
   * navigato to /servicesEmployeeMatch
   */
  $scope.navigateToServiceEmployeeMatch = function() {
    $state.go('private.main.serviceResourceMatch');
  };

  /**
   * open the service group modal
   */
  $scope.openServiceGroupModal = function() {
    ServiceGroupModal.open();
  };

  /**
   * save to database
   */
  $scope.save = function() {
    OfficeModel.update($scope.office, function(error) {
      if (error) {
        Notification.addErrorMessage({ text: error });
      } else {
        Notification.addSuccessMessage(gettextCatalog.getString('service edited'));
      }
    });
  };

  $scope.moveUp = function(arr, index) {
    if (index > 0) {
      arr.move(index, index - 1);
      $scope.save();
    }
  };

  $scope.moveDown = function(arr, index) {
    if (index < arr.length - 1) {
      arr.move(index, index + 1);
      $scope.save();
    }
  };

  var updateOffice = $rootScope.$on('Office:update', function(event, response) {
    $scope.office = response;
  });

  /**
   * remove event listener if day has changed (CalendarCtrl destroyed)
   */
  $scope.$on('$destroy', function() {
    updateOffice();
  });

  $scope.shouldHideDuration = function(service) {
    var posNum = _.get(service, 'accounting.posNum');
    return posNum && parseInt(posNum) >= 1250;
  };
};



// WEBPACK FOOTER //
// ./src/app/modules/service/list/listCtrl.js